<template>
    <span data-qa="ktv-sms-verification-status-alert-message">{{ i18nStatusMessage }}</span>
</template>

<script>
import { KMN_VERIFICATION_STATUS_TYPE as STATUSES } from '@/components/broadcast/constants/smsBroadcast.constants';
import { camelCase } from 'lodash';
import { getResubmissionDaysRemaining } from './automatedSms.util';

const TOLL_FREE = 'TOLL_FREE';

const VALID_STATUSES = Object.keys(STATUSES);

const RESTRICTED_STATUSES_20240130 = [
    STATUSES.PENDING_VERIFICATION,
    STATUSES.RESUBMISSION,
];

const i18nKeyStatusUnknown = 'unknown';

export default {
    props: {
        daysToResubmit: {
            type: Number,
            default: 7,
        },
        numberType: {
            type: String,
            default: TOLL_FREE,
        },
        rejectionDate: String,
        verificationStatus: {
            required: true,
            type: String,
            default: '',
        },
    },

    computed: {
        daysRemaining() {
            return getResubmissionDaysRemaining(this.rejectionDate);
        },

        i18nKeyStatus() {
            if (!VALID_STATUSES.includes(this.verificationStatus)) {
                return i18nKeyStatusUnknown;
            }

            if (this.verificationStatus === STATUSES.RESUBMISSION && this.daysRemaining < 1) {
                return camelCase(STATUSES.EXPIRED);
            }

            if (RESTRICTED_STATUSES_20240130.includes(this.verificationStatus)) {
                return `${camelCase(this.verificationStatus)}.restricted`;
            }

            return camelCase(this.verificationStatus) || i18nKeyStatusUnknown;
        },

        i18nLabelresubmissionTimeFrame() {
            return this.daysRemaining > 0
                ? this.$tc('sms.verification.withinDays', this.daysRemaining, { days: this.daysRemaining })
                : this.$t('global.today');
        },

        i18nStatusMessage() {
            return this.$t(`sms.verification.statuses.${this.i18nKeyStatus}.${camelCase(this.numberType)}`, {
                mayTakeAdditionalTime: this.$t('sms.verification.mayTakeAdditionalTime'),
                resubmissionTimeFrame: this.i18nLabelresubmissionTimeFrame,
            });
        },

        shouldEmphasizeAddtionalTime() {
            return this.i18nKeyStatus === camelCase(STATUSES.EXPIRED);
        },
    },
};
</script>
